// frontend/src/components/SetPasswordPage.js
import { useState } from "react";
import { updatePassword } from "@/lib/auth";

function SetPasswordPage({ onComplete }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await updatePassword(password);
      onComplete();
    } catch (err) {
      setError(err.message || "Failed to update password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F5EE] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-[#1E1E1E] px-6 py-4 text-center">
          <h1 className="text-xl text-[#F5EDE0]" style={{ fontFamily: "Federo, serif" }}>
            Set New Password
          </h1>
        </div>
        <form onSubmit={handleSubmit} className="leadline-border bg-[#F5EDE0] p-6 space-y-4">
          {error && (
            <div className="bg-[#E05A2D] text-[#F5EDE0] px-3 py-2 text-sm">{error}</div>
          )}
          <label className="block">
            <span className="block text-xs mb-1 text-[#3A3530]">New Password</span>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                className="w-full leadline-border-thin px-3 py-2 bg-white text-sm pr-16"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-[#3A3530] hover:underline"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </label>
          <label className="block">
            <span className="block text-xs mb-1 text-[#3A3530]">Confirm Password</span>
            <input
              type={showPassword ? "text" : "password"}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              className="w-full leadline-border-thin px-3 py-2 bg-white text-sm"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#2B7D6E] text-[#F5EDE0] py-2 text-sm leadline-border-thin disabled:opacity-50"
          >
            {loading ? "Updating..." : "Update Password"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default SetPasswordPage;
